
































































































































































































































/** @format */
import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';

import Utils from '@/utils/common';
// 导入字典
import { dictServiceTypeMap, makeInvoiceTypeMap } from '@/types/system-management/dictionaries';

import { createInvoiceAPI, updateInvoiceAPI, getInvoiceEditInfoAPI } from '@/api/setting-management';
import { saleCodeValidation, emailNot } from '@/utils/validators';
import { isNewHope } from '@/utils/env';
import * as _ from 'lodash';
@Component({
  components: {
    OrganizationSearch: () => import('@/components/organization-search/index.vue')
  }
})
export default class InvoiceSettingEdit extends Vue {
  form: any = null;

  // form布局
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 9 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 15 }
    }
  };

  private isUpdate: boolean = false;
  private isDisabled: boolean = false;

  // 表单需要的参数
  private formParams: any = {
    serviceType: '', // 开票服务商
    organId: '', // 所属机构
    companyName: '', // 企业名称
    registerCode: '', // 商户号
    platformTerminalCode: '', // 终端代码
    saleCode: '', // 开票项目
    companyAddress: '', //地址、电话
    mobile: '', //电话
    bankName: '', // 银行账号
    bankAccountNo: '', //账号
    email: '' //邮箱
  };
  validatorsSaleCod = saleCodeValidation; //税号校验
  specilService: boolean = false;
  isBaiWang: boolean = false;
  isNewHopeView: boolean = false;
  validatorEmail = emailNot;
  // 开票服务商
  get serviceTypeList() {
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries['cp_base_invoice_service_type']);
  }

  // 开票项目
  // private typeList: any[] = Utils.toLabelVal(makeInvoiceTypeMap)
  get typeList() {
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries['invoice_type']);
  }
  // 编辑详情数据
  private detailData: any = null;

  // 是否显示
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  /* // 详情数据
      @Prop({
        type: Object,
        default () {
          return null
        }
      })
      detailData!: EditInvoiceParams | null */

  // 机构ID
  @Prop({ type: String, default: '' })
  organizationId!: string;

  // 发票ID
  @Prop({ type: String, default: undefined })
  invoiceId!: string | undefined;

  // 是否显示操作按钮
  @Prop({ type: Boolean, default: true })
  showActions!: boolean;

  // 监听visible
  @Watch('visible', { immediate: true })
  onChangeVisible(newVal: boolean, oldVal: boolean) {
    if (newVal) {
      this.initData();
    }
  }

  // 监听发票ID
  @Watch('invoiceId', {})
  onChangeInvoiceId(newVal: string, oldVal: string) {
    this.initData();
  }

  /* // 监听detailData
      @Watch('detailData', { deep: true })
      onChangeDetailData (newVal: EditInvoiceParams | null, oldVal: EditInvoiceParams | null) {
        this.initData(newVal)
      } */

  // 取消编辑
  @Emit('cancel')
  handleCancel() {
    this.form.resetFields();
    return {
      isUpdate: this.isUpdate
    };
  }
  //获取开票服务商名称
  changeService(e: any) {
    let result: any = [];
    result = _.filter(this.serviceTypeList, function(o) {
      return o.value == e;
    });
    //新希望->新视窗
    if (isNewHope && result.length && result[0].value == '14') {
      this.isNewHopeView = true;
    } else {
      this.isNewHopeView = false;
    }
    if (result.length > 0 && result[0].label == '百旺智票盒子') {
      this.isBaiWang = true;
    } else {
      this.isBaiWang = false;
    }
    if ((result.length > 0 && result[0].label == '沪友') || (result.length > 0 && result[0].label.indexOf('大象') > -1))
      return (this.specilService = true);
    return (this.specilService = false);
  }
  // 验证税率
  validateTaxRate(rule: any, value: any, callback: any) {
    const isFloatNumber: any = /^(-?\d+)(\.\d+)?$/;
    if (value && (!isFloatNumber.test(value) || value <= 0 || value >= 100)) {
      callback('请输入0到100之间到数字！');
    } else {
      callback();
    }
  }

  // 编辑，提交，表单验证
  handleEditSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: any) => {
      if (!err) {
        if (this.isUpdate) {
          this.updateData(values);
        } else {
          this.createData(values);
        }
      }
    });
  }

  // 添加－请求数据
  async createData(values: any) {
    try {
      const { status, code, msg, data } = await createInvoiceAPI({
        ...values
      });
      if (status === '9999') {
        this.$message.success('创建成功');
        this.$emit('create', {});
        this.form.resetFields();
      } else {
        this.$message.error(msg || '创建失败！');
      }
    } catch (error) {
      // console.log(error)
      this.$message.error((error && error.msg) || '创建失败！');
    }
  }

  // 修改－请求数据
  async updateData(values: any) {
    try {
      const { invoiceId: pkInvoiceId } = this;
      const { status, code, msg, data } = await updateInvoiceAPI({
        ...values,
        pkInvoiceId
      });
      if (status === '9999') {
        this.$message.success('修改成功');
        this.$emit('update', {});
        this.form.resetFields();
      } else {
        this.$message.error(msg || '修改失败！');
      }
    } catch (error) {
      // console.log(error)
      this.$message.error((error && error.msg) || '修改失败！');
    }
  }

  // 获取编辑详情数据
  async getEditInfoData() {
    try {
      const { invoiceId } = this;
      const { status, code, msg, data } = await getInvoiceEditInfoAPI({
        pkInvoiceId: invoiceId
      });
      if (status === '9999') {
        this.detailData = data;
        // if (data.serviceType === '05' || data.serviceType === '06') {
        //   this.specilService = true
        // } else {
        //   this.specilService = false
        // }
        let result: any = [];
        result = _.filter(this.serviceTypeList, function(o) {
          return o.value == data.serviceType;
        });
        if (result.length > 0 && result[0].label == '百旺智票盒子') {
          this.isBaiWang = true;
        } else {
          this.isBaiWang = false;
        }
        if (result.length > 0 && result[0].label == '沪友') {
          this.specilService = true;
        } else {
          this.isBaiWang = false;
        }
        if (result.length > 0 && result[0].label == '大象') {
          this.specilService = true;
        } else {
          this.specilService = false;
        }
        // if (data.serviceType === '07') {
        //   this.isBaiWang = true
        // } else {
        //   this.isBaiWang = false
        // }
      } else {
        this.$message.error(msg || '获取详情失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '获取详情失败！');
    }
  }

  // 重置编辑表单
  async resetEditData(detailData: any) {
    if (detailData) {
      // 修改
      this.isUpdate = true;
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const params: any = {};
          Object.keys(this.formParams).forEach(item => {
            params[item] = this.$form.createFormField({
              value: detailData[item]
            });
          });
          return params;
        }
      });
    } else {
      // 添加
      this.isUpdate = false;
      this.form = this.$form.createForm(this, {});
    }
  }

  // 初始化数据
  async initData() {
    const { invoiceId } = this;
    this.detailData = null;
    if (invoiceId) {
      // 根据ID-判断是否编辑
      await this.getEditInfoData();
    }
    await this.resetEditData(this.detailData);
  }

  // 生命周期初始化
  async created() {
    // await this.initData()
  }

  async activated() {
    this.initData();
  }
}
